export default "__VITE_ASSET__DgkeVhcJ__"